'use strict';

import React, { Component } from 'react'

import { DateTime } from 'luxon'

import { IoCloudDownloadOutline } from 'react-icons/io5'

import bemit from '@function/bemit'

import { num, formatNum } from '@root/utility'

export default function FrontBillRow ({ data, blank=true, fields, ...props })
{
	const multiplier = data.text_number.startsWith('A-') ? -1 : 1;

	const total_price = num(data.total_price * multiplier);

	const pdf_href = data.text_number.startsWith('A')
	? '/PDF/avoir/' + data.id
	: '/PDF/facture/' + data.id;

	return (
		<div className="c-dashboard__row">

			<div className="c-dashboard__cell Bill-date">
				{ DateTime.fromISO(data.date).toFormat('dd/MM/yyyy') }
			</div>

			<div className="c-dashboard__cell Bill-order_number">
				{ data.order_number || '/' }
			</div>

			<div className="c-dashboard__cell Bill-total_price">
				{ formatNum(total_price, '0,0[.]00') }
				{ ' €' }
			</div>

			<div className="c-dashboard__cell Bill-paid_amount">
				{ formatNum(data.paid_amount, '0,0[.]00') }
				{ ' €' }
			</div>

			<div className="c-dashboard__cell Bill-remaining_unpaid">
				{ formatNum(data.remaining_unpaid, '0,0[.]00') }
				{ ' €' }
			</div>

			<div className="c-dashboard__cell Bill-number">

				<div className="c-dashboard__cell-self-aligned">

					<a rel="noreferrer" type="application/pdf"
						target="_blank" href={ pdf_href }
						title="Télécharger la facture"
						className={ bemit('c-table-btn', ['in-cell', 'icon']) }>
						<IoCloudDownloadOutline className="c-table-btn__icon" />
						<span className="c-table-btn__label">
							{ data.text_number }
						</span>
					</a>

				</div>

			</div>

		</div>
	);
}